import ChangePasswordCard from "./ChangePasswordCard";
import TwoFactorCard from "./TwoFactorCard";
import SecurityTipsCard from "./SecurityTipsCard";
import SecurityScoreCard from "./SecurityScoreCard";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function SecurityTab({ onShowToast }) {
  return (
    <div className={styles.contentGrid}>
      <div className={styles.contentMain}>
        <ChangePasswordCard onShowToast={onShowToast} />
        <TwoFactorCard onShowToast={onShowToast} />
      </div>
      <div className={styles.contentSide}>
        <SecurityTipsCard />
        <SecurityScoreCard />
      </div>
    </div>
  );
}
